<template>
  <div class="bar-progress" ref="bar" @click.stop="clickProgressAction">
    <!-- 条形进度条 -->
    <div
      class="progress"
      ref="progress"
      :style="{ width: 100 * value + '%' }"
    ></div>
    <div class="handler" ref="handler" @touchstart="touchstartAction"></div>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    screenWidth: null
  },
  data () {
    return {
      barWidth: 0
    }
  },
  watch: {
    value (newValue) {
      this.$refs.handler.style.transform = `translateY(-50%) translateX(${newValue * this.barWidth}px)`;
    },
    screenWidth (newValue) {
      this.barWidth = this.$refs.bar.offsetWidth
      this.$refs.handler.style.transform = `translateY(-50%) translateX(${this.value * this.barWidth}px)`;
    }
  },
  methods: {
    // 触摸开始，给dom添加触摸移动和停止的事件
    touchstartAction (ev) {
      document.ontouchmove = this.touchmoveAction;
      document.ontouchend = this.touchEndAction;
      document.ontouchcancel = this.touchEndAction;

      // 记录开始的位置
      const position = this.value * this.barWidth;//进度条触摸开始时的位置
      this.startX = ev.changedTouches[0].clientX - position;

      this.$emit('touch', true);
    },
    touchmoveAction (ev) {
      const currentX = ev.changedTouches[0].clientX;
      let tmp = currentX - this.startX;
      if (tmp < 0 || tmp > this.barWidth) {
        return;
      }
      this.offsetX = tmp;
      // 设置点的位置
      this.$refs.handler.style.transform = `translateY(-50%) translateX(${this.offsetX}px)`;
      // 设置进度条的宽度
      this.$refs.progress.style.width = this.offsetX + 'px';
    },
    touchEndAction () {
      //修改进度
      const newValue = (this.offsetX / this.barWidth).toFixed(2);
      this.$emit('input', newValue);
      // 移除事件
      document.ontouchmove = null;
      document.ontouchend = null;
      document.ontouchcancel = null;
    },
    // 点击事件修改进度
    clickProgressAction (e) {
      console.log(e.offsetX);
      console.log(this.barWidth);
      const newValue = (e.offsetX / this.barWidth).toFixed(2);
      // 设置点的位置
      this.$refs.handler.style.transform = `translateY(-50%) translateX(${e.offsetX}px)`;
      // 设置进度条的宽度
      this.$refs.progress.style.width = e.offsetX + 'px';
      this.$emit('input', newValue);
    }
  },
  mounted () {
    // 设置进度的初始位置
    this.barWidth = this.$refs.bar.offsetWidth;
    this.$refs.handler.style.transform = `translateY(-50%) translateX(${this.value * this.barWidth}px)`;
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/global-style.scss';
.progress-loaded {
  background-color: #b1b2b6;
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 10px;
  z-index: -10;
  border-radius: 5px;
  transition: all 16ms;
  display: block;
}
.bar-progress {
  width: 100%;
  // width: 1189px;
  height: 10px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.2);
  position: relative;
  margin: 0 auto;
}
.progress {
  height: 100%;
  width: 0;
  background: #fd9552;
  border-radius: 5px;
}
.handler {
  position: absolute;
  top: 50%;
  left: -4px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 4px solid #fff;
  border-radius: 50%;
  background: $theme-color;
  @extend .entend_click;
}
</style>